// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"96":"ab79cfd529552e53","8662":"84e7a7524cd72dca"}[chunkId] + ".css";
};